import React from "react";
import { useState, useEffect } from "react";

import Corpo from "../components/Corpo";

import { findStatistic } from "../services/user-service";

export default function Statistic(props) {
  const [statistic, setStatistic] = useState([]);

  let calcPercentage = (correct, wrong) => {
    if(correct === 0 && wrong === 0){
      return (0).toFixed(2);
    }
    return (correct * 100 / (correct + wrong)).toFixed(2);
  }

  useEffect(() => {
    const abortController = new AbortController();

    findStatistic().then((res) => {
      setStatistic(res.data);
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-estatisticas pane pane-game">
          <div
            className="scroll-content ionic-scroll  has-tabs-top"
            style={{ top: "56px" }}
          >
            <div className="scroll">
              <h2 className="title">Estatísticas</h2>
              <div className="content-table">
                {statistic.map((conteudo, key) => {
                  return (
                    <div key={key}>
                      <h3>{conteudo.nomeCategoria}</h3>
                      <dl>
                        <div>
                          <dt>{conteudo.nomeTema}</dt>
                          <dd>
                            <div className="row">
                              <div className="col">
                                Single - {
                                  calcPercentage(conteudo.corretoSingleplayer, conteudo.erradoSingleplayer)
                                }%
                              </div>
                              <div className="col text-right">
                                {
                                  calcPercentage(conteudo.vitoriasMultiplayer, conteudo.derrotasMultiplayer)
                                }% - Multi
                              </div>
                            </div>
                          </dd>
                        </div>
                      </dl>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
